// extracted by mini-css-extract-plugin
export default {"main":"Menu_main__g0ate"};